<template>
  <article class="organizacion">
    <section class="portada">
      <div class="linea">
        <h1>Organización</h1>
      </div>
    </section>
    <section class="lineas">
      <div class="linea1"></div>
      <div class="linea2"></div>
      <div class="linea3"></div>
    </section>
    <section class="descripcion">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 col-sm-12 col-md-8">
            <p><strong>Compañía Mega S.A.</strong> cuenta con un grupo humano altamente calificado y con la experiencia necesaria para operar con excelencia en la gestión de cada uno de los procesos que conforman la empresa.</p>
            <p>Alineada con su Política de Gestión, la organización está orientada al desarrollo de sus actividades con eficiencia y calidad en cada una de sus áreas.</p>
          </div>
        </div>
      </div>
    </section>
    <section class="secundario">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 col-sm-12 col-md-8">
            <h2>Áreas de la compañía</h2>
            <img src="./Feb-2019-organigrama.jpg" alt="Organigrama" class="img-fluid">
          </div>
        </div>
      </div>
    </section>
  </article>
</template>

<script>
export default {
  name: 'Organizacion'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">
</style>



// WEBPACK FOOTER //
// src/components/organizacion-en/Organizacion-en.vue